
import * as defaultImport from "@splunk/visualization-themes/helper";
export * from "@splunk/visualization-themes/helper";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
